import { render, staticRenderFns } from "./kk-menu-down.vue?vue&type=template&id=60e3e831&"
import script from "./kk-menu-down.vue?vue&type=script&lang=js&"
export * from "./kk-menu-down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports